import { JurisdictionOverrideConflictError } from '@/lib/api'
import type { JurisdictionOverrideConflictCode, Tripwire } from '@/types/jurisdictions'

// Market-exit playbook tripwires 1 to 3: the ones that fire an immediate provisional block.
export const TRIPWIRE_LABELS: Record<Tripwire, string> = {
    1: 'Order naming us (cease-and-desist, blocking or payment)',
    2: 'Written counsel advice to exit',
    3: 'Vendor compliance action on the market',
}

const CONFLICT_COPY: Record<JurisdictionOverrideConflictCode, string> = {
    OVERRIDE_ACTIVE: 'This country already has a provisional block.',
    MATRIX_BLOCKED: 'The jurisdiction matrix already blocks this country.',
    ALREADY_LIFTED: 'This block was already lifted.',
}

export function overrideErrorMessage(err: unknown): string {
    if (err instanceof JurisdictionOverrideConflictError) return CONFLICT_COPY[err.code]
    if (err instanceof Error && err.message) return err.message
    return 'The request failed. Try again.'
}

// An override this old should have become a matrix change (BLO-848).
export const MATRIX_CHANGE_DUE_DAYS = 14

export function ageInDays(createdAt: string, now: Date): number {
    return Math.max(0, Math.floor((now.getTime() - new Date(createdAt).getTime()) / 86_400_000))
}
